import { render, staticRenderFns } from "./ServiceWorkSheet.vue?vue&type=template&id=513c5912&scoped=true"
import script from "./ServiceWorkSheet.vue?vue&type=script&lang=js"
export * from "./ServiceWorkSheet.vue?vue&type=script&lang=js"
import style0 from "./ServiceWorkSheet.vue?vue&type=style&index=0&id=513c5912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c5912",
  null
  
)

export default component.exports